import { getAlertList } from '@src/api/manualAlerts';
import { useQuery } from '@tanstack/react-query';
import { getMetricInfo } from '../../constants';
import moment from 'moment';

const defaultData = {
  alerts: [],
  eventCounts: {},
};

const useFetchAlerts = (interval) => {
  const metricsInfo = getMetricInfo();
  const { from, to } = interval;

  const {
    isFetching,
    isLoading,
    data = defaultData,
  } = useQuery(
    ['manual-alert', 'list', interval],
    async () => {
      const res = await getAlertList({
        params: {
          from: moment(from).format(),
          to: moment(to).format(),
        },
      });
      const { alerts, eventCounts } = res.data;
      return {
        eventCounts,
        alerts: alerts.map((alert) => {
          if (metricsInfo[alert.metric].units === 'Mbps') {
            alert.threshold = (alert.threshold * 1e-6).toPrecision(3);
          }
          return alert;
        }),
      };
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1 * 60 * 1000, // 1m
      //placeholderData: defaultData,
      keepPreviousData: true, // for background refetch on changes
    },
  );

  return { isFetching, isLoading, data };
};

export default useFetchAlerts;
